import {useNavigate} from 'react-router-dom';


import * as orderConstants from '../orderConstants';
import * as urlUtils from '../../../../utils/urlUtils';

import orderService from '../../../../services/OrderService';


/**
 * @return {function} Submission function
 */
function useSubmitOrderFromCart() {

    const navigate = useNavigate();

    /**
     * @param response {ApiResponse}
     */
    const onError = response => {

        const error = response.isConflict()
            ? response.getBody().message
            : orderConstants.SUBMISSION_ERROR_OTHER;
        const submissionErrorUrl = urlUtils.buildUrl(
            orderConstants.NAV_PAGE_ORDER_CONFIRMATION_ERROR,
            {},
            {error}
        );

        return navigate(submissionErrorUrl);
    };

    /**
     * @param cartId {string} Id of the cart to submit as an order
     * @return {orderId: string, orderNumber: string} Order submission respnose data
     */
    return async cartId => {

        const orderResponse = await orderService.submitCart(cartId);
        if (orderResponse.isErroneous()) {

            return onError(orderResponse);
        }

        return orderResponse.getBody();
    };
}


export default useSubmitOrderFromCart;
